// One money format for the whole app: "£1,234.50", "-£8.05", "€12.00", "CHF 12.00" for codes with no symbol.
// String decimals stay exact (no float round trip); numbers are shown to 2 dp. Unknown or blank is "—", never £0.
const SYMBOLS = { GBP: '£', EUR: '€', USD: '$', INR: '₹' };

export function formatMoney(value, currency = 'GBP', { minScale = 2 } = {}) {
  if (value === null || value === undefined || value === '') return '—';
  let text = typeof value === 'number' ? (Number.isFinite(value) ? value.toFixed(Math.max(2, minScale)) : '') : String(value).trim();
  const match = /^([+-]?)(\d+)(?:\.(\d+))?$/.exec(text);
  if (!match) return String(value);
  const [, sign, whole, fraction = ''] = match;
  let kept = fraction.replace(/0+$/, '');
  if (kept.length < minScale) kept = kept.padEnd(minScale, '0');
  const grouped = whole.replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const code = (currency || 'GBP').toUpperCase();
  const symbol = SYMBOLS[code] ?? `${code} `;
  const negative = sign === '-' && /[1-9]/.test(whole + kept);
  return `${negative ? '-' : ''}${symbol}${grouped}${kept ? `.${kept}` : ''}`;
}
